/*
 *
 *  actions
 *
 */

import {
  //LOAD_VIDEO_TEAM
  LOAD_PURCHASE_INVOICE_REPORT,
  LOAD_PURCHASE_INVOICE_REPORT_SUCCESS,
  LOAD_PURCHASE_INVOICE_REPORT_ERROR,
  CREATE_PURCHASE_INVOICE,
  CREATE_PURCHASE_INVOICE_SUCCESS,
  CREATE_PURCHASE_INVOICE_ERROR,
  UPDATE_PURCHASE_INVOICE,
  UPDATE_PURCHASE_INVOICE_SUCCESS,
  UPDATE_PURCHASE_INVOICE_ERROR,
  LOAD_PARTY_VENDOR_ADDRESS,
  LOAD_PARTY_VENDOR_ADDRESS_SUCCESS,
  LOAD_PARTY_VENDOR_ADDRESS_ERROR,
  CREATE_PARTY_VENDOR_ADDRESS,
  CREATE_PARTY_VENDOR_ADDRESS_SUCCESS,
  CREATE_PARTY_VENDOR_ADDRESS_ERROR,
  DELETE_PURCHASE_INVOICE,
  DELETE_PURCHASE_INVOICE_SUCCESS,
  DELETE_PURCHASE_INVOICE_ERROR,
  LOAD_REPORTS_META_DATA,
  LOAD_REPORTS_META_DATA_SUCCESS,
  LOAD_REPORTS_META_DATA_ERROR,
  LOAD_PARTIES_TRANSACTION,
  LOAD_PARTIES_TRANSACTION_SUCCESS,
  LOAD_PURCHASE_INVOICE_CATEGORY,
  LOAD_PURCHASE_INVOICE_CATEGORY_SUCCESS,
  LOAD_PURCHASE_INVOICE_CATEGORY_ERROR,
  CREATE_PURCHASE_INVOICE_PARTIES_CATEGORY,
  CREATE_PURCHASE_INVOICE_PARTIES_CATEGORY_SUCCESS,
  CREATE_PURCHASE_INVOICE_PARTIES_CATEGORY_ERROR,
  LOAD_PARTIES_TRANSACTION_ERROR,
  LOAD_REPORTS_DASHBOARD_TRANSACTION,
  LOAD_REPORTS_DASHBOARD_TRANSACTION_SUCCESS,
  LOAD_REPORTS_DASHBOARD_TRANSACTION_ERROR,
  LOAD_PURCHASE_REPORT_TOTAL,
  LOAD_PURCHASE_REPORT_TOTAL_SUCCESS,
  LOAD_PURCHASE_REPORT_TOTAL_ERROR,
  LOAD_TOTAL_REPORT_PAID,
  LOAD_TOTAL_REPORT_PAID_SUCCESS,
  LOAD_TOTAL_REPORT_PAID_ERROR,
  LOAD_TOTAL_REPORT_UNPAID,
  LOAD_TOTAL_REPORT_UNPAID_SUCCESS,
  LOAD_TOTAL_REPORT_UNPAID_ERROR,
  LOAD_PURCHASE_INVOICE_BARCODE,
  LOAD_PURCHASE_INVOICE_BARCODE_SUCCESS,
  LOAD_PURCHASE_INVOICE_BARCODE_ERROR,
  LOAD_LEDGER_STATEMENT_REPORT,
  LOAD_LEDGER_STATEMENT_REPORT_SUCCESS,
  LOAD_LEDGER_STATEMENT_REPORT_ERROR,
  LOAD_STOCK_REPORT_DETAILS,
  LOAD_STOCK_REPORT_DETAILS_SUCCESS,
  LOAD_STOCK_REPORT_DETAILS_ERROR,
  LOAD_ITEMS_QUANTITY_REPORT,
  LOAD_ITEMS_QUANTITY_REPORT_SUCCESS,
  LOAD_ITEMS_QUANTITY_REPORT_ERROR,
  LOAD_BARCODE_DETAILS_REPORT,
  LOAD_BARCODE_DETAILS_REPORT_SUCCESS,
  LOAD_BARCODE_DETAILS_REPORT_ERROR,
  LOAD_SALES_ITEMS_QUANTITY_REPORT,
  LOAD_SALES_ITEMS_QUANTITY_REPORT_SUCCESS,
  LOAD_SALES_ITEMS_QUANTITY_REPORT_ERROR,
  LOAD_SALES_FILTER_REPORT,
  LOAD_SALES_FILTER_REPORT_SUCCESS,
  LOAD_SALES_FILTER_REPORT_ERROR,
  LOAD_SALES_RETURN_REPORT,
  LOAD_SALES_RETURN_REPORT_SUCCESS,
  LOAD_SALES_RETURN_REPORT_ERROR,
  LOAD_SALES_RETURN_ITEMS_REPORT,
  LOAD_SALES_RETURN_ITEMS_REPORT_SUCCESS,
  LOAD_SALES_RETURN_ITEMS_REPORT_ERROR,

  //sales & purchase summary
  LOAD_SALES_SUMMARY_REPORT,
  LOAD_SALES_SUMMARY_REPORT_SUCCESS,
  LOAD_SALES_SUMMARY_REPORT_ERROR,
  LOAD_PURCHASE_SUMMARY_REPORT,
  LOAD_PURCHASE_SUMMARY_REPORT_SUCCESS,
  LOAD_PURCHASE_SUMMARY_REPORT_ERROR,
  LOAD_BILL_STATUS_META_DATA,
  LOAD_BILL_STATUS_META_DATA_SUCCESS,
  LOAD_BILL_STATUS_META_DATA_ERROR,
  LOAD_PARTY_WISE_OUTSTANDING_REPORT,
  LOAD_PARTY_WISE_OUTSTANDING_REPORT_SUCCESS,
  LOAD_PARTY_WISE_OUTSTANDING_REPORT_ERROR,

  //Profit report
  LOAD_PROFIT_REPORT_LIST,
  LOAD_PROFIT_REPORT_LIST_SUCCESS,
  LOAD_PROFIT_REPORT_LIST_ERROR,
} from "./constants";

// load purchase
export function loadPurchaseInvoice(salesInvoiceList) {
  return {
    type: LOAD_PURCHASE_INVOICE_REPORT,
    salesInvoiceList,
  };
}

export function loadPurchaseInvoiceSuccess(purchase_invoice_list, success) {
  return {
    type: LOAD_PURCHASE_INVOICE_REPORT_SUCCESS,
    purchase_invoice_list,
    success,
  };
}

export function loadPurchaseInvoiceError(error) {
  return {
    type: LOAD_PURCHASE_INVOICE_REPORT_ERROR,
    error,
  };
}

// load barCode
export function loadPurchaseBarcode(salesInvoiceList) {
  return {
    type: LOAD_PURCHASE_INVOICE_BARCODE,
    salesInvoiceList,
  };
}

export function loadPurchaseBarcodeSuccess(purchase_barcode_list, success) {
  return {
    type: LOAD_PURCHASE_INVOICE_BARCODE_SUCCESS,
    purchase_barcode_list,
    success,
  };
}

export function loadPurchaseBarcodeError(error) {
  return {
    type: LOAD_PURCHASE_INVOICE_BARCODE_ERROR,
    error,
  };
}
// load purchase receipt
export function loadLedgerStatmentList(partyLedger) {
  return {
    type: LOAD_LEDGER_STATEMENT_REPORT,
    partyLedger,
  };
}

export function loadLedgerStatmentListSuccess(party_ledger_statement, success) {
  return {
    type: LOAD_LEDGER_STATEMENT_REPORT_SUCCESS,
    party_ledger_statement,
    success,
  };
}

export function loadLedgerStatmentListError(error) {
  return {
    type: LOAD_LEDGER_STATEMENT_REPORT_ERROR,
    error,
  };
}

// load purchase receipt
export function loadPartyWiseOutstandingReport(partyLedger) {
  return {
    type: LOAD_PARTY_WISE_OUTSTANDING_REPORT,
    partyLedger,
  };
}

export function loadPartyWiseOutstandingReportSuccess(
  party_wise_outstanding,
  success
) {
  return {
    type: LOAD_PARTY_WISE_OUTSTANDING_REPORT_SUCCESS,
    party_wise_outstanding,
    success,
  };
}

export function loadPartyWiseOutstandingReportError(error) {
  return {
    type: LOAD_PARTY_WISE_OUTSTANDING_REPORT_ERROR,
    error,
  };
}

// load parties
export function loadDashboardTransactions(transactionsList) {
  return {
    type: LOAD_REPORTS_DASHBOARD_TRANSACTION,
    transactionsList,
  };
}

export function loadDashboardTransactionsSuccess(
  dashboard_transactions,
  success
) {
  return {
    type: LOAD_REPORTS_DASHBOARD_TRANSACTION_SUCCESS,
    dashboard_transactions,
    success,
  };
}

export function loadDashboardTransactionsError(error) {
  return {
    type: LOAD_REPORTS_DASHBOARD_TRANSACTION_ERROR,
    error,
  };
}

// load total balance
export function loadPurchaseTotal(transactionsList) {
  return {
    type: LOAD_PURCHASE_REPORT_TOTAL,
    transactionsList,
  };
}

export function loadPurchaseTotalSuccess(purchase_total_list, success) {
  return {
    type: LOAD_PURCHASE_REPORT_TOTAL_SUCCESS,
    purchase_total_list,
    success,
  };
}

export function loadPurchaseTotalError(error) {
  return {
    type: LOAD_PURCHASE_REPORT_TOTAL_ERROR,
    error,
  };
}

// load total balance
export function loadTotalPaid(transactionsList) {
  return {
    type: LOAD_TOTAL_REPORT_PAID,
    transactionsList,
  };
}

export function loadTotalPaidSuccess(total_paid_list, success) {
  return {
    type: LOAD_TOTAL_REPORT_PAID_SUCCESS,
    total_paid_list,
    success,
  };
}

export function loadTotalPaidError(error) {
  return {
    type: LOAD_TOTAL_REPORT_PAID_ERROR,
    error,
  };
}

// load total balance
export function loadTotalUnPaid(transactionsList) {
  return {
    type: LOAD_TOTAL_REPORT_UNPAID,
    transactionsList,
  };
}

export function loadTotalUnPaidSuccess(total_unpaid_list, success) {
  return {
    type: LOAD_TOTAL_REPORT_UNPAID_SUCCESS,
    total_unpaid_list,
    success,
  };
}

export function loadTotalUnPaidError(error) {
  return {
    type: LOAD_TOTAL_REPORT_UNPAID_ERROR,
    error,
  };
}

// load pary address
export function loadPartyVendorAddress(PurchaseInvoiceList) {
  return {
    type: LOAD_PARTY_VENDOR_ADDRESS,
    PurchaseInvoiceList,
  };
}

export function loadPartyVendorAddressSuccess(party_address_list, success) {
  return {
    type: LOAD_PARTY_VENDOR_ADDRESS_SUCCESS,
    party_address_list,
    success,
  };
}

export function loadPartyVendorAddressError(error) {
  return {
    type: LOAD_PARTY_VENDOR_ADDRESS_ERROR,
    error,
  };
}

// Category

export function loadPartiesCategory(categoryList) {
  return {
    type: LOAD_PURCHASE_INVOICE_CATEGORY,
    categoryList,
  };
}

export function loadPartiesCategorySuccess(category_list, success) {
  return {
    type: LOAD_PURCHASE_INVOICE_CATEGORY_SUCCESS,
    category_list,
    success,
  };
}

export function loadPartiesCategoryError(error) {
  return {
    type: LOAD_PURCHASE_INVOICE_CATEGORY_ERROR,
    error,
  };
}

//category list
export function createPartiesCategoryList(categoryList) {
  return {
    type: CREATE_PURCHASE_INVOICE_PARTIES_CATEGORY,
    categoryList,
  };
}

export function createPartiesCategoryListSuccess(categoryList, success) {
  return {
    type: CREATE_PURCHASE_INVOICE_PARTIES_CATEGORY_SUCCESS,
    categoryList,
    success,
  };
}

export function createPartiesCategoryListError(error) {
  return {
    type: CREATE_PURCHASE_INVOICE_PARTIES_CATEGORY_ERROR,
    error,
  };
}

// party address create
export function createPartyVendorAddress(partyAddress) {
  return {
    type: CREATE_PARTY_VENDOR_ADDRESS,
    partyAddress,
  };
}

export function createPartyVendorAddressSuccess(partyAddress, success) {
  return {
    type: CREATE_PARTY_VENDOR_ADDRESS_SUCCESS,
    partyAddress,
    success,
  };
}

export function createPartyVendorAddressError(error) {
  return {
    type: CREATE_PARTY_VENDOR_ADDRESS_ERROR,
    error,
  };
}

// load parties
export function createPurchaseInvoiceList(purchaseInvoiceList) {
  return {
    type: CREATE_PURCHASE_INVOICE,
    purchaseInvoiceList,
  };
}

export function createPurchaseInvoiceListSuccess(purchaseInvoiceList, success) {
  return {
    type: CREATE_PURCHASE_INVOICE_SUCCESS,
    purchaseInvoiceList,
    success,
  };
}

export function createPurchaseInvoiceListError(error) {
  return {
    type: CREATE_PURCHASE_INVOICE_ERROR,
    error,
  };
}
// load parties
export function updatePurchaseInvoiceList(salesInvoiceList) {
  return {
    type: UPDATE_PURCHASE_INVOICE,
    salesInvoiceList,
  };
}

export function updatePurchaseInvoiceListSuccess(salesInvoiceList, success) {
  return {
    type: UPDATE_PURCHASE_INVOICE_SUCCESS,
    salesInvoiceList,
    success,
  };
}

export function updatePurchaseInvoiceListError(error) {
  return {
    type: UPDATE_PURCHASE_INVOICE_ERROR,
    error,
  };
}
// load parties
export function deletePurchaseInvoiceList(salesInvoiceList) {
  return {
    type: DELETE_PURCHASE_INVOICE,
    salesInvoiceList,
  };
}

export function deletePurchaseInvoiceListSuccess(salesInvoiceList, success) {
  return {
    type: DELETE_PURCHASE_INVOICE_SUCCESS,
    salesInvoiceList,
    success,
  };
}

export function deletePurchaseInvoiceListError(error) {
  return {
    type: DELETE_PURCHASE_INVOICE_ERROR,
    error,
  };
}

// load parties transaction
export function loadPartiesTransaction(purchaseInvoiceList) {
  return {
    type: LOAD_PARTIES_TRANSACTION,
    purchaseInvoiceList,
  };
}

export function loadPartiesTransactionSuccess(
  parties_transaction_list,
  success
) {
  return {
    type: LOAD_PARTIES_TRANSACTION_SUCCESS,
    parties_transaction_list,
    success,
  };
}

export function loadPartiesTransactionError(error) {
  return {
    type: LOAD_PARTIES_TRANSACTION_ERROR,
    error,
  };
}

export function loadPurchaseInvoiceRecordsMetaData() {
  return {
    type: LOAD_REPORTS_META_DATA,
  };
}

/**
 *
 * @param {object} recordsMetaData
 * @returns
 */
export function loadPurchaseInvoiceRecordsMetaDataSuccess(recordsMetaData) {
  return {
    type: LOAD_REPORTS_META_DATA_SUCCESS,
    recordsMetaData,
  };
}

/**
 *
 * @param {string} error
 * @returns
 */
export function loadPurchaseInvoiceRecordsMetaDataError(error) {
  return {
    type: LOAD_REPORTS_META_DATA_ERROR,
    error,
  };
}

export function loadBillStatusMetaData() {
  return {
    type: LOAD_BILL_STATUS_META_DATA,
  };
}

/**
 *
 * @param {object} recordsMetaData
 * @returns
 */
export function loadBillStatusMetaDataSuccess(billStatusMetaData) {
  return {
    type: LOAD_BILL_STATUS_META_DATA_SUCCESS,
    billStatusMetaData,
  };
}

/**
 *
 * @param {string} error
 * @returns
 */
export function loadBillStatusMetaDataError(error) {
  return {
    type: LOAD_BILL_STATUS_META_DATA_ERROR,
    error,
  };
}

//stock report

export function loadStockReportList(stockDetails) {
  return {
    type: LOAD_STOCK_REPORT_DETAILS,
    stockDetails,
  };
}

export function loadStockReportListSuccess(stock_report_list, success) {
  return {
    type: LOAD_STOCK_REPORT_DETAILS_SUCCESS,
    stock_report_list,
    success,
  };
}

export function loadStockReportListError(error) {
  return {
    type: LOAD_STOCK_REPORT_DETAILS_ERROR,
    error,
  };
}

//stock report

export function loadItemQuantityReport(stockDetails) {
  return {
    type: LOAD_ITEMS_QUANTITY_REPORT,
    stockDetails,
  };
}

export function loadItemQuantityReportSuccess(item_quantity_report, success) {
  return {
    type: LOAD_ITEMS_QUANTITY_REPORT_SUCCESS,
    item_quantity_report,
    success,
  };
}

export function loadItemQuantityReportError(error) {
  return {
    type: LOAD_ITEMS_QUANTITY_REPORT_ERROR,
    error,
  };
}

//stock report

export function loadBarcodeReportList(stockDetails) {
  return {
    type: LOAD_BARCODE_DETAILS_REPORT,
    stockDetails,
  };
}

export function loadBarcodeReportListSuccess(barcode_report_list, success) {
  return {
    type: LOAD_BARCODE_DETAILS_REPORT_SUCCESS,
    barcode_report_list,
    success,
  };
}

export function loadBarcodeReportListError(error) {
  return {
    type: LOAD_BARCODE_DETAILS_REPORT_ERROR,
    error,
  };
}
//profit loss report

export function loadProfitLossReportList(stockDetails) {
  return {
    type: LOAD_PROFIT_REPORT_LIST,
    stockDetails,
  };
}

export function loadProfitLossReportListSuccess(profit_report_list, success) {
  return {
    type: LOAD_PROFIT_REPORT_LIST_SUCCESS,
    profit_report_list,
    success,
  };
}

export function loadProfitLossReportListError(error) {
  return {
    type: LOAD_PROFIT_REPORT_LIST_ERROR,
    error,
  };
}

//sales item report

export function loadSalesItemQtyReport(stockDetails) {
  return {
    type: LOAD_SALES_ITEMS_QUANTITY_REPORT,
    stockDetails,
  };
}

export function loadSalesItemQtyReportSuccess(
  sales_item_quantity_report,
  success
) {
  return {
    type: LOAD_SALES_ITEMS_QUANTITY_REPORT_SUCCESS,
    sales_item_quantity_report,
    success,
  };
}

export function loadSalesItemQtyReportError(error) {
  return {
    type: LOAD_SALES_ITEMS_QUANTITY_REPORT_ERROR,
    error,
  };
}

//sales report

export function loadSalesFiltersReport(stockDetails) {
  return {
    type: LOAD_SALES_FILTER_REPORT,
    stockDetails,
  };
}

export function loadSalesFiltersReportSuccess(sales_filter_report, success) {
  return {
    type: LOAD_SALES_FILTER_REPORT_SUCCESS,
    sales_filter_report,
    success,
  };
}

export function loadSalesFiltersReportError(error) {
  return {
    type: LOAD_SALES_FILTER_REPORT_ERROR,
    error,
  };
}

//sales summary report

export function loadSalesSummaryReport(stockDetails) {
  return {
    type: LOAD_SALES_SUMMARY_REPORT,
    stockDetails,
  };
}

export function loadSalesSummaryReportSuccess(sales_summary_report, success) {
  return {
    type: LOAD_SALES_SUMMARY_REPORT_SUCCESS,
    sales_summary_report,
    success,
  };
}

export function loadSalesSummaryReportError(error) {
  return {
    type: LOAD_SALES_SUMMARY_REPORT_ERROR,
    error,
  };
}

//purchase summary report

export function loadPurchaseSummaryReport(stockDetails) {
  return {
    type: LOAD_PURCHASE_SUMMARY_REPORT,
    stockDetails,
  };
}

export function loadPurchaseSummaryReportSuccess(
  purchase_summary_report,
  success
) {
  return {
    type: LOAD_PURCHASE_SUMMARY_REPORT_SUCCESS,
    purchase_summary_report,
    success,
  };
}

export function loadPurchaseSummaryReportError(error) {
  return {
    type: LOAD_PURCHASE_SUMMARY_REPORT_ERROR,
    error,
  };
}

//sales return report

export function loadSalesReturnReport(stockDetails) {
  return {
    type: LOAD_SALES_RETURN_REPORT,
    stockDetails,
  };
}

export function loadSalesReturnReportSuccess(sales_return_report, success) {
  return {
    type: LOAD_SALES_RETURN_REPORT_SUCCESS,
    sales_return_report,
    success,
  };
}

export function loadSalesReturnReportError(error) {
  return {
    type: LOAD_SALES_RETURN_REPORT_ERROR,
    error,
  };
}

//sales return items report

export function loadSalesReturnItemsReport(stockDetails) {
  return {
    type: LOAD_SALES_RETURN_ITEMS_REPORT,
    stockDetails,
  };
}

export function loadSalesReturnItemsReportSuccess(
  sales_return_items_report,
  success
) {
  return {
    type: LOAD_SALES_RETURN_ITEMS_REPORT_SUCCESS,
    sales_return_items_report,
    success,
  };
}

export function loadSalesReturnItemsReportError(error) {
  return {
    type: LOAD_SALES_RETURN_ITEMS_REPORT_ERROR,
    error,
  };
}

const actions = {
  loadPurchaseInvoice,
  loadPurchaseInvoiceSuccess,
  loadPurchaseInvoiceError,

  loadPurchaseBarcode,
  loadPurchaseBarcodeSuccess,
  loadPurchaseBarcodeError,
  
  loadProfitLossReportList,
  loadProfitLossReportListSuccess,
  loadProfitLossReportListError,
  
  loadLedgerStatmentList,
  loadLedgerStatmentListSuccess,
  loadLedgerStatmentListError,

  loadPartyWiseOutstandingReport,
  loadPartyWiseOutstandingReportSuccess,
  loadPartyWiseOutstandingReportError,

  loadDashboardTransactions,
  loadDashboardTransactionsSuccess,
  loadDashboardTransactionsError,

  loadPurchaseTotal,
  loadPurchaseTotalSuccess,
  loadPurchaseTotalError,
  loadTotalPaid,
  loadTotalPaidSuccess,
  loadTotalPaidError,
  loadTotalUnPaid,
  loadTotalUnPaidSuccess,
  loadTotalUnPaidError,

  loadPartyVendorAddress,
  loadPartyVendorAddressSuccess,
  loadPartyVendorAddressError,

  loadPartiesCategory,
  loadPartiesCategorySuccess,
  loadPartiesCategoryError,

  createPartiesCategoryList,
  createPartiesCategoryListSuccess,
  createPartiesCategoryListError,

  loadPartiesTransaction,
  loadPartiesTransactionSuccess,
  loadPartiesTransactionError,

  createPurchaseInvoiceList,
  createPurchaseInvoiceListSuccess,
  createPurchaseInvoiceListError,

  createPartyVendorAddress,
  createPartyVendorAddressSuccess,
  createPartyVendorAddressError,

  updatePurchaseInvoiceList,
  updatePurchaseInvoiceListSuccess,
  updatePurchaseInvoiceListError,
  loadBarcodeReportList,
  loadBarcodeReportListSuccess,
  loadBarcodeReportListError,

  deletePurchaseInvoiceList,
  deletePurchaseInvoiceListSuccess,
  deletePurchaseInvoiceListError,

  loadPurchaseInvoiceRecordsMetaData,
  loadPurchaseInvoiceRecordsMetaDataSuccess,
  loadPurchaseInvoiceRecordsMetaDataError,

  loadBillStatusMetaData,
  loadBillStatusMetaDataSuccess,
  loadBillStatusMetaDataError,

  // stock report
  loadStockReportList,
  loadStockReportListSuccess,
  loadStockReportListError,

  loadItemQuantityReport,
  loadItemQuantityReportSuccess,
  loadItemQuantityReportError,

  loadSalesItemQtyReport,
  loadSalesItemQtyReportSuccess,
  loadSalesItemQtyReportError,

  loadSalesFiltersReport,
  loadSalesFiltersReportSuccess,
  loadSalesFiltersReportError,

  loadSalesReturnReport,
  loadSalesReturnReportSuccess,
  loadSalesReturnReportError,

  loadSalesReturnItemsReport,
  loadSalesReturnItemsReportSuccess,
  loadSalesReturnItemsReportError,

  loadSalesSummaryReport,
  loadSalesSummaryReportSuccess,
  loadSalesSummaryReportError,

  loadPurchaseSummaryReport,
  loadPurchaseSummaryReportSuccess,
  loadPurchaseSummaryReportError,
};

export default actions;
